const TheScheduleSettingResourcesPage = () =>
  import('@/views/settings/schedule/resources/TheScheduleSettingResourcesPage')

export const settingsResourcesRoutes = [
  {
    path: 'resources',
    name: 'settings_list_resources_route',
    component: TheScheduleSettingResourcesPage,
    meta: {
      breadcrumb: [
        { title: 'content_title', active: false },
        { title: 'content_company_title', active: true }
      ]
    }
  }
]
